import gql from 'graphql-tag';

export const buyPackMutation = gql`
  mutation buyPack($input: BuyPack!) {
    buyPack(input: $input) {
      message
    }
  }
`;
